import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const PDFIcon = ({ size = 15, ...props }: Props) => (
<svg
    width={size}
    height={size}
    viewBox="0 0 38 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.3}>
      <path
        opacity={0.3}
        d="M26.0402 9.18221C25.0209 9.18122 24.0436 8.77585 23.3229 8.0551C22.6021 7.33434 22.1968 6.35707 22.1958 5.33778V0H5.01712C3.68649 0 2.41038 0.528603 1.46948 1.4695C0.528591 2.41039 0 3.68648 0 5.0171V35.2615C0.00197597 36.5908 0.531434 37.8651 1.47211 38.8043C2.41279 39.7436 3.68778 40.2712 5.01712 40.2712H25.6393C26.9687 40.2712 28.2437 39.7436 29.1843 38.8043C30.125 37.8651 30.6545 36.5908 30.6564 35.2615V9.18221H26.0402Z"
        fill="#FF3E4C"
      />
    </g>
    <path
      d="M30.6565 9.18221H26.0402C25.0209 9.18122 24.0436 8.77585 23.3229 8.0551C22.6021 7.33434 22.1968 6.35707 22.1958 5.33778V0L30.6565 9.18221Z"
      fill="#FF3E4C"
    />
    <path
      d="M24.3491 28.123H5.10101C4.91558 28.123 4.73775 28.0493 4.60663 27.9182C4.47551 27.7871 4.40186 27.6093 4.40186 27.4238C4.40235 27.2387 4.47623 27.0614 4.60729 26.9307C4.73835 26.8 4.9159 26.7266 5.10101 26.7266H24.3491C24.5341 26.7266 24.7114 26.8 24.8422 26.9308C24.973 27.0615 25.0464 27.2389 25.0464 27.4238C25.0467 27.5156 25.0288 27.6065 24.9939 27.6913C24.959 27.7761 24.9076 27.8531 24.8429 27.9181C24.7781 27.983 24.7012 28.0346 24.6164 28.0697C24.5317 28.1049 24.4409 28.123 24.3491 28.123Z"
      fill="#FF3E4C"
    />
    <path
      d="M24.3491 20.248H5.10101C4.9159 20.248 4.73835 20.1746 4.60729 20.0439C4.47623 19.9131 4.40235 19.7358 4.40186 19.5507C4.40186 19.3653 4.47551 19.1874 4.60663 19.0563C4.73775 18.9252 4.91558 18.8516 5.10101 18.8516H24.3491C24.4409 18.8516 24.5317 18.8697 24.6164 18.9048C24.7012 18.94 24.7781 18.9915 24.8429 19.0564C24.9076 19.1214 24.959 19.1985 24.9939 19.2833C25.0288 19.3681 25.0467 19.459 25.0464 19.5507C25.0464 19.7356 24.973 19.913 24.8422 20.0438C24.7114 20.1745 24.5341 20.248 24.3491 20.248Z"
      fill="#FF3E4C"
    />
    <path
      d="M24.3491 24.1855H5.10101C4.91558 24.1855 4.73775 24.1118 4.60663 23.9807C4.47551 23.8496 4.40186 23.6718 4.40186 23.4863C4.40235 23.3012 4.47623 23.1239 4.60729 22.9932C4.73835 22.8625 4.9159 22.7891 5.10101 22.7891H24.3491C24.5341 22.7891 24.7114 22.8625 24.8422 22.9933C24.973 23.1241 25.0464 23.3014 25.0464 23.4863C25.0467 23.5781 25.0288 23.669 24.9939 23.7538C24.959 23.8386 24.9076 23.9157 24.8429 23.9806C24.7781 24.0456 24.7012 24.0971 24.6164 24.1322C24.5317 24.1674 24.4409 24.1855 24.3491 24.1855Z"
      fill="#FF3E4C"
    />
    <path
      d="M16.7573 16.3105H5.10101C4.9159 16.3105 4.73835 16.2371 4.60729 16.1064C4.47623 15.9757 4.40235 15.7983 4.40186 15.6132C4.40186 15.4278 4.47551 15.25 4.60663 15.1188C4.73775 14.9877 4.91558 14.9141 5.10101 14.9141H16.7573C16.9424 14.9146 17.1197 14.9884 17.2505 15.1195C17.3812 15.2505 17.4546 15.4281 17.4546 15.6132C17.4541 15.798 17.3805 15.9751 17.2498 16.1057C17.1191 16.2364 16.9421 16.31 16.7573 16.3105Z"
      fill="#FF3E4C"
    />
    <path
      d="M16.7573 12.373H5.10101C4.9159 12.373 4.73835 12.2996 4.60729 12.1689C4.47623 12.0381 4.40235 11.8608 4.40186 11.6757C4.40186 11.4903 4.47551 11.3124 4.60663 11.1813C4.73775 11.0502 4.91558 10.9766 5.10101 10.9766H16.7573C16.9424 10.9771 17.1197 11.0509 17.2505 11.182C17.3812 11.313 17.4546 11.4906 17.4546 11.6757C17.4541 11.8605 17.3805 12.0376 17.2498 12.1682C17.1191 12.2989 16.9421 12.3725 16.7573 12.373Z"
      fill="#FF3E4C"
    />
    <path
      d="M34.2938 31.8086H10.9813C9.32763 31.8086 7.98706 33.1492 7.98706 34.8028V41.7533C7.98706 43.407 9.32763 44.7476 10.9813 44.7476H34.2938C35.9475 44.7476 37.2881 43.407 37.2881 41.7533V34.8028C37.2881 33.1492 35.9475 31.8086 34.2938 31.8086Z"
      fill="#FF3E4C"
    />
    <path d="M15.6349 39.7832V41.1386H14.2329V39.7832H15.6349Z" fill="white" />
    <path
      d="M17.697 39.1716V41.1385H16.3416V35.5322H18.5378C19.2034 35.5322 19.7124 35.6981 20.061 36.0281C20.2375 36.2015 20.3752 36.4102 20.4652 36.6406C20.5551 36.871 20.5953 37.1179 20.5831 37.3649C20.5899 37.6909 20.5094 38.0127 20.35 38.2971C20.1873 38.5752 19.946 38.799 19.6565 38.9404C19.3073 39.1054 18.9239 39.1853 18.5378 39.1734L17.697 39.1716ZM19.2034 37.3649C19.2034 36.8677 18.9312 36.6191 18.3868 36.6191H17.697V38.079H18.3868C18.9312 38.084 19.2034 37.8459 19.2034 37.3649Z"
      fill="white"
    />
    <path
      d="M25.9395 39.7868C25.706 40.2108 25.3534 40.5569 24.9252 40.7825C24.4435 41.0291 23.9077 41.1515 23.3666 41.1385H21.2505V35.5323H23.3666C23.9081 35.5187 24.4446 35.6384 24.929 35.8809C25.356 36.1016 25.7077 36.4443 25.9395 36.8653C26.1821 37.3123 26.3041 37.8148 26.2937 38.3233C26.3038 38.8335 26.1818 39.3377 25.9395 39.7868ZM24.4815 39.5053C24.6331 39.3498 24.7505 39.1643 24.8262 38.9607C24.902 38.7572 24.9345 38.5401 24.9215 38.3233C24.9345 38.1068 24.9021 37.8899 24.8264 37.6867C24.7506 37.4834 24.6331 37.2983 24.4815 37.1431C24.1424 36.8456 23.6994 36.6941 23.2491 36.7218H22.6059V39.9248H23.2491C23.6991 39.9521 24.1417 39.8015 24.4815 39.5053Z"
      fill="white"
    />
    <path
      d="M30.7181 35.5322V36.6117H28.4193V37.8403H30.1942V38.8714H28.4193V41.1385H27.062V35.5322H30.7181Z"
      fill="white"
    />
    <path
      d="M24.008 10.9766H20.7117C20.1372 10.9766 19.6714 11.4423 19.6714 12.0169V15.3132C19.6714 15.8877 20.1372 16.3535 20.7117 16.3535H24.008C24.5826 16.3535 25.0483 15.8877 25.0483 15.3132V12.0169C25.0483 11.4423 24.5826 10.9766 24.008 10.9766Z"
      fill="#FF3E4C"
    />
  </svg>
);
export default PDFIcon;
